import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container-fluid bg-white mt-4\"><div class=\"col-12 d-flex gap-5 justify-content-center align-items-center px-2 py-3\"></div></div><div class=\"footer-v2 pb-3 pt-4 public-footer text-center bg-primary\"><div class=\"container text-start\"><div class=\"row\"></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _hoisted_1
}